export const AppleStore = {
    BRASIL: "https://apps.apple.com/br/app/universo-médico/id1562197992",
    MEXICO: "https://apps.apple.com/mx/app/bescience-app/id1644400127",
    CONOSUR: "https://apps.apple.com/app/universo-médico/id1594412044",
    PACA: "https://apps.apple.com/app/universo-medico-app/id1599519330"
};


// WEBPACK FOOTER //
// ./src/helpers/enums/AppleStoreEnum.js